import React, { useState, useEffect, useContext } from "react";
import { Card, Container, Tab, Nav, Row, Col } from "react-bootstrap";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import StoreContext from "contexts/StoreContext";
import RestaurantTable from "views/Components/RestaurantTable";
import RefreshButton from "views/Components/RefreshButton";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function RestaurantPlanPage() {
  const { t } = useTranslation();

  const [tables, setTables] = useState([]);
  const [tablesPlanData, setTablesPlanData] = useState([]);
  const [tableRegions, setTableRegions] = useState([]);
  const { storeId, setStoreId } = useContext(StoreContext);
  const [className, setClassName] = useState("shadow border-0");
  const [isDisabled, setIsDisabled] = useState(false);
  const [showLoader, setShowLoader] = useState(true);

  const fetchData = async () => {
    try {
      setIsDisabled(true);
      setShowLoader(true);
      const dataTables = await apiService.get(`api/v1/tables/store/${storeId}`);
      dataTables.sort((a, b) => a.order - b.order);
      const activeTables = dataTables.filter((o) => !o.deleted && !o.temporary);
      setTables(activeTables);

      const dataOpenTables = await apiService.get(`api/v1/tables/store/${storeId}/open`);
      setTablesPlanData(
        activeTables.map((table) => {
          const commonItem = dataOpenTables.find((o) => o.table_id === table.id);
          return {
            ...table,
            isOpened: !!commonItem,
            total: commonItem ? "€" + commonItem.total.toFixed(2) : null,
          };
        })
      );

      const dataTableRegions = await apiService.get(`api/v1/table-regions/store/${storeId}`);
      setTableRegions(dataTableRegions.filter((o) => !o.deleted));
      setIsDisabled(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
      setIsDisabled(false);
    } finally {
      setShowLoader(false);
    }
  };

  const fetchOpenTables = async () => {
    try {
      setIsDisabled(true);
      const dataOpenTables = await apiService.get(`api/v1/tables/store/${storeId}/open`);
      setTablesPlanData(
        tables.map((table) => {
          const commonItem = dataOpenTables.find((o) => o.table_id === table.id);
          return {
            ...table,
            isOpened: !!commonItem,
            total: commonItem ? "€" + commonItem.total.toFixed(2) : null,
          };
        })
      );
      setIsDisabled(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
      setIsDisabled(false);
    }
  };

  const handleRefresh = () => {
    fetchOpenTables();
  };

  useEffect(() => {
    if (!storeId) return;
    fetchData();
  }, [storeId]);

  useEffect(() => {
    if (!storeId) return;
    const interval = setInterval(() => {
      fetchOpenTables();
    }, 1000 * 60);
    return () => clearInterval(interval);
  }, [storeId, tables]);

  return (
    <>
      <Container fluid>
        <Card>
          <Card.Header>
            <Card.Title as="h4" className="pb-2 border-bottom">
              <Row>
                <Col>{t("common.labels.tables")}</Col>
                <Col>
                  <RefreshButton refresh={handleRefresh} disabled={isDisabled} />
                </Col>
              </Row>
            </Card.Title>
          </Card.Header>
          <Card.Body>
            {showLoader ? (
              <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
                <ClipLoader size={50} color={"#ff6fbc"} />
              </div>
            ) : (
              <Tab.Container id="plain-tabs-example" defaultActiveKey="0">
                <Nav role="tablist" variant="tabs">
                  {tableRegions.length === 0 ? (
                    <h5 className="ml-4">{t("messages.noTableRegionsAvailable")}</h5>
                  ) : (
                    tableRegions.map((region, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link eventKey={index.toString()}>{region.name}</Nav.Link>
                      </Nav.Item>
                    ))
                  )}
                </Nav>
                <Tab.Content className="m-4">
                  {tableRegions.length === 0
                    ? ""
                    : tableRegions.map((region, index) => (
                        <Tab.Pane eventKey={index.toString()} key={index}>
                          <Row>
                            {tablesPlanData
                              .filter((table) => table.region.id == region.id)
                              .map((table, index) => (
                                <div key={index}>
                                  <RestaurantTable
                                    tableId={table.id}
                                    tableName={table.name}
                                    tableColor={table.color}
                                    className={className}
                                    isOpened={table.isOpened}
                                    total={table.total}
                                  />
                                </div>
                              ))}
                          </Row>
                        </Tab.Pane>
                      ))}
                </Tab.Content>
              </Tab.Container>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default RestaurantPlanPage;
